import { useMutation, useQueryClient } from '@tanstack/react-query'
import { createUserPermissions } from 'api/admin/userPermissions/createUserPermissions'
import { getUIPermission } from 'api/admin/userPermissions/permissions'
import { useWhoamiContextValue } from 'components/Whoami/WhoamiProvider'
import { userPermissionsKeys } from 'queries/admin/userPermissions/keys'

export function useCreateUserPermissionsMutation() {
  const queryClient = useQueryClient()
  const { hasPermission } = useWhoamiContextValue()
  const permission = getUIPermission(hasPermission)
  return useMutation({
    mutationFn: (request: Parameters<typeof createUserPermissions>[0]) =>
      createUserPermissions(request, permission || 'permission_admin'),
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: userPermissionsKeys.all,
      })
    },
  })
}
